export default "__VITE_ASSET__eb607fe1__"